const loadDictionary = (lang) => lang === "ru"
    ? import("./dictionaries/ru.json")
    : import("./dictionaries/en.json");
export default loadDictionary;
//# sourceMappingURL=loadDictionary.js.map